// @flow
import * as React from 'react';
import './header-logo.scss';

export const HeaderLogo = () => {
  return (
    <div className="logo">
      {/* <img src="/images/gmn_logo.png" alt="login"/> */}
    </div>
  );
};
